import type { FieldArrayMethodProps, FieldArrayWithId } from 'react-hook-form';
import { TotemSelect } from 'components/TotemSelect';
import React from 'react';
import styled from 'styled-components';
import { SupplierType } from 'pages/Products/constants/defaultProduct';
import { GetSuppliersQuery } from 'data/__generated__';

type SupplierFields = FieldArrayWithId<
    {
        suppliers: SupplierType[];
    },
    'suppliers',
    'id'
>[];

export const SupplierSelector = ({
    prepend,
    supplierFields,
    suppliers,
}: {
    prepend: (value: SupplierType | SupplierType[], options?: FieldArrayMethodProps | undefined) => void;
    supplierFields: SupplierFields;
    suppliers: GetSuppliersQuery['suppliers'];
}) => {
    const onSelect = (value: string | null) => {
        if (value && !supplierFields.some(({ _id }) => _id === value)) {
            prepend({ _id: value, code: '', prices: [] });
        }
    };

    const supplierOptions = suppliers.map(({ _id, name }: { _id: string; name: string }) => ({
        value: _id,
        label: name,
    }));

    return (
        <SelectorContainer>
            <TotemSelect
                label="Ajouter un fournisseur "
                placeholder="Recherche par nom ou par _id"
                value={null}
                options={supplierOptions}
                onChange={onSelect}
                dataTest="product-supplier"
            />
        </SelectorContainer>
    );
};

const SelectorContainer = styled.div`
    width: 100%;
    font-size: 15px;
`;
